import React from "react"
import clsx from "clsx"

export default class Rating extends React.Component {
	
	constructor(props) {
		super(props);

		this.state = {
			tempValue: this.props.value || null,
		}

		this.onChange = this.onChange.bind(this);
		this.onMouseEnter = this.onMouseEnter.bind(this);
		this.onMouseLeave = this.onMouseLeave.bind(this);
	}

	render() {
		// console.log('Rating', this.props)
		var stars = this.props.stars.map((star) => {
			var { id, value } = star
			return this.renderStar(id, value)
		})

		return (
			<div className="Rating">{stars}</div>
		)
	}

	renderStar(id, value) {
		if (this.state.tempValue !== this.props.value) {
			var stateValue = this.state.tempValue
		} else {
			var stateValue = this.props.value;
		}
		var starValue = this.getStarValue(stateValue)
		var starClasses = clsx(
			'Star',
			starValue && starValue >= value && 'StarActive'
		)

		return (
			<span key={value} 
						data-value={id}
						className={starClasses}
						onClick={this.onChange} 
						onMouseEnter={this.onMouseEnter} 
						onMouseLeave={this.onMouseLeave}>☆</span>
		)
	}

	/*
	* Change Handlers
	*/

	onMouseEnter(e) {
		this.setState({tempValue: e.target.dataset.value});
	}

	onMouseLeave(e) {
		this.setState({tempValue: this.props.value});
	}

	onChange(e) {
		e.stopPropagation();
		e.preventDefault();

		this.props.onChange('RATING', this.props.question.id, {options: [{id: e.target.dataset.value}]})
	}

	/**
	* Helper functions
	*/

	getStarValue(id) {
		for (var i = 0, ilen = this.props.stars.length; i < ilen; i++) {
			var star = this.props.stars[i]
			if (star.id === id) {
				return star.value;
			}
		}
	}

}